export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/a92d826d80900dda6092d3b109ffaee1.svg";